<template>
  <div>
    <div class="main-container">
      <div class="sidebar">
        <nav class="sidebar-nav">
          <ul class="nav">
            <li class="nav-title">Navigation</li>

            <li class="nav-item">
              <router-link to="/" exact class="nav-link">
                <i class="icon icon-home"></i> Home
              </router-link>
            </li>
            <li v-if="user" class="nav-item">
              <router-link to="/dice/devices/all" class="nav-link">
                <i class="fa fa-laptop"></i> Devices
              </router-link>
            </li>
            <li v-if="user" class="nav-item">
              <router-link to="/dice/orders/all" class="nav-link">
                <i class="fa fa-truck"></i> Orders
              </router-link>
            </li>
            <li
              v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') ||
         user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||
          user.profile.role.includes('NowMicro_Support') ||
          user.profile.role.includes('DiceLive'))"
              class="nav-item"
            >
              <router-link to="/dice/devices/reports" class="nav-link">
                <i class="fas fa-file-alt"></i> Reports
              </router-link>
            </li>
            <li v-if="user" class="nav-item">
              <router-link to="/tickets" class="nav-link">
                <i class="fa fa-life-ring"></i> Support Tickets
              </router-link>
            </li>
            <li v-if="user" class="nav-item">
              <router-link to="/support/schedule" class="nav-link">
                <i class="fa fa-users"></i> ConsultNow
              </router-link>
            </li>
            <li v-if="user && gpCustomerNumber == 'HENN002'" class="nav-item">
              <a
                href="https://store.nowmicro.com/shop/86fjUULsdAxTEZ9t"
                target="_blank"
                class="nav-link"
              >
                <i class="fas fa-shopping-cart"></i> Store
              </a>
            </li>
            <li
              v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator')) || gpCustomerNumber == 'ACME001'"
              class="nav-item"
            >
              <a
                href="https://store.nowmicro.com/shop/ZRGFR91UJJG45LB4"
                target="_blank"
                class="nav-link"
              >
                <i class="fas fa-shopping-cart"></i> Store
              </a>
            </li>
            <li v-if="user" class="nav-item nav-dropdown">
              <a href="#" class="nav-link nav-dropdown-toggle">
                <i class="fa fa-question" aria-hidden="true"></i> Help
                <i class="fa fa-caret-left"></i>
              </a>
              <ul class="nav-dropdown-items">
                <li v-if="user" class="nav-item">
                  <router-link to="/home/updates" exact class="nav-link">Updates</router-link>
                </li>
                <li v-if="user" class="nav-item">
                  <router-link to="/home/feedback" exact class="nav-link">Submit Feedback</router-link>
                </li>
              </ul>
            </li>
            <li
              v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('Configurator') || user.profile.role.includes('Device_Management'))"
              class="nav-item nav-dropdown"
            >
              <a href="#" class="nav-link nav-dropdown-toggle">
                <i class="fas fa-grip-horizontal"></i> Other Applications
                <i class="fa fa-caret-left"></i>
              </a>
              <ul class="nav-dropdown-items">
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('Configurator'))"
                  class="nav-item"
                >
                  <a :href="url + '/policies'" class="nav-link">Configurator</a>
                </li>
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('Device_Management'))"
                  class="nav-item"
                >
                  <a :href="url + '/manageddevices'" class="nav-link">Device Management</a>
                </li>
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('Device_Management'))"
                  class="nav-item"
                >
                  <a :href="url + '/content'" class="nav-link">Content</a>
                </li>
              </ul>
            </li>
            <li
              v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||  user.profile.role.includes('NowMicro_Support'))"
              class="nav-item nav-dropdown"
            >
              <a href="#" class="nav-link nav-dropdown-toggle">
                <i class="icon icon-user"></i> Administration
                <i class="fa fa-caret-left"></i>
              </a>

              <ul class="nav-dropdown-items">
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||  user.profile.role.includes('NowMicro_Support'))"
                  class="nav-item"
                >
                  <a :href="url + '/applicationusers'" class="nav-link">User Management</a>
                </li>
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||  user.profile.role.includes('NowMicro_Support'))"
                  class="nav-item"
                >
                  <a :href="url + '/organizations'" class="nav-link">Organization Management</a>
                </li>
                <li
                  v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||  user.profile.role.includes('NowMicro_Support'))"
                  class="nav-item"
                >
                  <a :href="url + '/account/inviteuser'" class="nav-link">Invite a User</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        {{version}}
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>



<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Mgr from "@/services/SecurityService";
import UserService from "@/components/general/UserService.vue";

export default {
  props: {
    user: Object,
    logout: Function,
    login: Function,
    version: String
  },
  components: {
    UserService
  },
  data: function() {
    return {
      mgr: new Mgr(),
      url: process.env.VUE_APP_CONFIG_URI,
      gpCustomerNumber: null
    };
  },
  computed: {
    storeUrl() {
      return "https://store.nowmicro.com/shop/86fjUULsdAxTEZ9t";
    }
  },
  methods: {
    parseJwt() {
      var base64Url = this.user.access_token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      this.gpCustomerNumber = JSON.parse(jsonPayload).gpcustomernumber;

      return JSON.parse(jsonPayload);
    }
  },
  created() {
    this.parseJwt();
  }
};
</script>
<style>
</style>